import axiosInstance from '../config/axios.config';

// Tenant Admin endpoints (expected). If not available, calls will fail gracefully.
export const adminLookupService = {
  // Companies: initial fetch (first 10 alphabetical)
  fetchCompaniesInitial: async () => {
    try {
      const { data } = await axiosInstance.get('/admin/companies', {
        params: { limit: 10, order: 'name_asc' }
      });
      const list = Array.isArray(data?.data) ? data.data : Array.isArray(data?.items) ? data.items : [];
      return list.map(c => ({ label: c.name ?? `Company ${c.id}` , value: c.id }));
    } catch (e) {
      // Silent fail; return empty
    }
    return [];
  },

  // Companies: search after 3 chars
  searchCompanies: async (q) => {
    if (!q || q.length < 3) return [];
    try {
      const { data } = await axiosInstance.get('/admin/companies', {
        params: { search: q, limit: 10, order: 'name_asc' }
      });
      const list = Array.isArray(data?.data) ? data.data : Array.isArray(data?.items) ? data.items : [];
      return list.map(c => ({ label: c.name ?? `Company ${c.id}` , value: c.id }));
    } catch (e) {}
    return [];
  },

  // Unified Users search: single endpoint with optional company_id (middleware injects for company_admin)
  searchUsers: async ({ q, company_id, limit = 10, offset = 0 }) => {
    // Allow empty q for initial lists; backend should return top results
    try {
      const params = { limit, offset, order: 'name_asc' };
      if (q !== undefined) params.search = q;
      if (company_id) params.company_id = company_id;
      const { data } = await axiosInstance.get('/users', { params });
      const list = Array.isArray(data?.data) ? data.data : Array.isArray(data?.items) ? data.items : [];
      return list.map(u => ({ label: `${u.name ?? u.email} (${u.email})`, value: u.id }));
    } catch (e) {
      return [];
    }
  },

  // Backward compatibility wrappers
  searchTenantUsers: async ({ q, company_id }) => {
    if (q && q.length < 3) return [];
    return adminLookupService.searchUsers({ q, company_id, limit: 10, offset: 0 });
  },
  searchCompanyUsers: async (q) => {
    if (q && q.length < 3) return [];
    return adminLookupService.searchUsers({ q, limit: 10, offset: 0 });
  }
};
